import {barnManagerModule} from '../index.module';

barnManagerModule.controller('GlueController', GlueController);

GlueController.$inject = ['$rootScope'];
function GlueController($rootScope) {
  $rootScope.$broadcast('$showLoader', false);
}
